import { createCtx } from './create-context.helper';
import { ProjectView } from '@lib/api-interface';

export const [useProjectContext, ProjectContextProvider] = createCtx<ProjectView>();
